export class EditUserData {

	userName: string;
	userCpf: number;
	userEditable: boolean;
	userCellphone: string;
	userEmail: string;
	userBrazilian: string;
	userUF: string;
	userNaturalness: string;
	userMotherName: string;
	userBirthDate: any;
	userLabelBirthDate: any;
	userRG: string;
	userGender: string;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/models/edit-user-data.ts